import { Obra } from "../../../../../infraestructure/persistence/rest/ObrasAdapter";

export const createOptions = (data:any) =>{
  return data.map((o: Obra)=> { return { label: `${o.centroObra} - ${o.obra}`, value: o.centroObra } })
}